import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45ee607e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]
const _hoisted_2 = ["src", "alt"]

import { StyleValue, withDefaults } from "vue";
export interface BannerProps {
  show?: boolean;
  src?: string;
  alt?: string;
  style?: StyleValue;
  href?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Banner',
  props: {
    show: { type: Boolean, default: false },
    src: null,
    alt: null,
    style: null,
    href: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "banner",
    style: _normalizeStyle(__props.style)
  }, [
    (__props.show)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: __props.href
        }, [
          (__props.src !== undefined)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: __props.src,
                alt: __props.alt
              }, null, 8, _hoisted_2))
            : _createCommentVNode("", true)
        ], 8, _hoisted_1))
      : _createCommentVNode("", true)
  ], 4))
}
}

})